import React from 'react';
import { Grid } from 'components/ui';
import { ContentSpan } from 'components/styles_components/span';
import { DescriptionTypography } from 'components/styles_components/typography';
import theme from 'theme';

const ShowItemRow = ({ label, color, children }) => {
  return (
    <Grid size={{ xs: 12, lg: 12 }} color={color} justifyContent="center">
      <DescriptionTypography sx={{ width: { xs: 'auto', sm: theme.width.descriptionItem } }}>
        {label}:
      </DescriptionTypography>{' '}
      <ContentSpan>{children}</ContentSpan>
    </Grid>
  );
};

export default ShowItemRow;
